module.exports = __webpack_public_path__ + "img/c-logo.80dcb869.png";